<main class="login-container">
  <div class="background-gif"></div>
  <div>
    <div class="login-card">
      <div class="logo-container">
        <img src="assets/images/Logo/login-logo.svg" alt="CSQ Logo" class="logo">
      </div>
      <h1 class="welcome-text">Experience Portal</h1>
      <h1 class="welcome-text">Forgot Password?</h1>
      <p class="login-subtext">Enter the email address associated with your account
        and we'll send you a link to reset your password.</p>

      <form class="login-form" [formGroup]="forgotForm" (ngSubmit)="onForgotFormSubmit()">
        <div class="form-group">
          <label for="email">Email</label>
          <div class="input-container">
            <img src="assets/images/sms.svg" alt="email icon" class="icon">
            <input type="email" id="email" formControlName="email" placeholder="Enter your email" [class.disabled]="isLoading"
              [ngClass]="{'invalid-input': forgotForm.get('email')?.invalid && (forgotForm.get('email')?.touched || formSubmit)}" />
          </div>

          <div class="login-error-message-container">
            <!-- Show required error -->
            <div class="login-error-message"
              *ngIf="forgotForm.get('email')?.hasError('required') && (forgotForm.get('email')?.touched || formSubmit)">
              Please enter a email address.
            </div>

            <!-- Show email format error (from Angular's email validator or custom pattern) -->
            <div class="login-error-message" *ngIf="(forgotForm.get('email')?.hasError('email') || 
                                                   forgotForm.get('email')?.hasError('pattern') || 
                                                   forgotForm.get('email')?.hasError('invalidEmail')) && 
                                                   (forgotForm.get('email')?.touched || formSubmit) && 
                                                   !forgotForm.get('email')?.hasError('required')">
              Please enter a valid email address.
            </div>
          </div>
        </div>

        <button type="submit" class="reset-button" [class.disabled]="isLoading">
          <ng-container *ngIf="!isLoading">Send Reset Link</ng-container>
          <ng-container *ngIf="isLoading">
            Send reset link <div class="spinner"></div>
          </ng-container>
        </button>

        <div class="back-link">
          <a routerLink="/auth/login" [class.disabled]="isLoading">
            Back to Login
          </a>
        </div>
      </form>
    </div>
  </div>

  <p class="login-subtext">
    Should you require immediate assistance, please contact CSQ at
    <a href="tel:1800798488" class="contact-phone">1800 798 488</a> or
    <br>
    email us at <a href="mailto:constructionpathways@csq.org.au"
      class="contact-email">constructionpathways&#64;csq.org.au</a>
  </p>
</main>